import { createSlice } from '@reduxjs/toolkit';
import {
    getBlogList,
    getBlogCategories,
    deleteBlogCategory,
    createBlog,
    updateBlog,
    findBlogById,
    createBlogCategory,
    createBlogAuthor,
    getBlogAuthors,
    deleteBlogAuthor,
    migrateAuthor,
    deleteMigrateAuthor,
    createMigrateAuthor,
    getDetailMigrateAuthors,
    migrateQuickEditApi
} from '../apis/blogs';

const initialState = {
    loading: false,
    blogList: {},
    categories: [],
    error: null,
    currentBlog: null,
    authors: [],
    migrateAuthorsList: [],
    fetchingAuthors: false,
    updatingAuthor: false,
    fetchingAuthor: false,
    currentAuthor: null,
};



const blogsSlice = createSlice({
    name: 'blogs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBlogList.pending, (state) => {
                state.fetchingBlogs = true;
                state.error = null;
            })
            .addCase(getBlogList.fulfilled, (state, action) => {
                state.fetchingBlogs = false;
                state.blogList = action.payload;
            })
            .addCase(getBlogList.rejected, (state, action) => {
                state.fetchingBlogs = false;
                state.error = action.payload;
            })
            .addCase(getBlogCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBlogCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload.categories;
            })
            .addCase(getBlogCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteBlogCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBlogCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload.categories;
            })
            .addCase(deleteBlogCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createBlogCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createBlogCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = (action.payload?.categories || []);
            })
            .addCase(createBlogCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(findBlogById.pending, (state) => {
                state.fetchingBlogs = true;
                state.error = null;
            })
            .addCase(findBlogById.fulfilled, (state, action) => {
                state.fetchingBlogs = false;
                state.currentBlog = action.payload;
            })
            .addCase(findBlogById.rejected, (state, action) => {
                state.fetchingBlogs = false;
                state.error = action.payload;
            })
            .addCase(updateBlog.pending, (state) => {
                state.updatingBlog = true;
                state.error = null;
            })
            .addCase(updateBlog.fulfilled, (state, action) => {
                state.updatingBlog = false;
            })
            .addCase(updateBlog.rejected, (state, action) => {
                state.updatingBlog = false;
                state.error = action.payload;
            })
            .addCase(createBlog.pending, (state) => {
                state.creatingBlog = true;
                state.error = null;
            })
            .addCase(createBlog.fulfilled, (state, action) => {
                state.creatingBlog = false;
            })
            .addCase(createBlog.rejected, (state, action) => {
                state.creatingBlog = false;
                state.error = action.payload;
            })
            .addCase(createBlogAuthor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createBlogAuthor.fulfilled, (state, action) => {
                state.loading = false;
                state.authors = action.payload?.authors || [];
            })
            .addCase(createBlogAuthor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getBlogAuthors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBlogAuthors.fulfilled, (state, action) => {
                state.loading = false;
                state.authors = action.payload.authors || [];
            })
            .addCase(getBlogAuthors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteBlogAuthor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBlogAuthor.fulfilled, (state, action) => {
                state.loading = false;
                if (state.authors) {
                    state.authors = action.payload.authors;
                }
            })
            .addCase(deleteBlogAuthor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Hyperwolf/Hemp Author and Migrate blog

            .addCase(migrateAuthor.pending, (state) => {
                state.fetchingAuthors = true;
                state.error = null;
            })
            .addCase(migrateAuthor.fulfilled, (state, action) => {
                console.log("action.payload", action.payload);

                state.fetchingAuthors = false;
                state.migrateAuthorsList = action.payload;
            })
            .addCase(migrateAuthor.rejected, (state, action) => {
                state.fetchingAuthors = false;
                state.error = action.payload;
            })
            .addCase(deleteMigrateAuthor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteMigrateAuthor.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteMigrateAuthor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createMigrateAuthor.pending, (state) => {
                state.updatingAuthor = true;
                state.error = null;
            })
            .addCase(createMigrateAuthor.fulfilled, (state, action) => {
                state.updatingAuthor = false;
            })
            .addCase(createMigrateAuthor.rejected, (state, action) => {
                state.updatingAuthor = false;
                state.error = action.payload;
            })
            .addCase(getDetailMigrateAuthors.pending, (state) => {
                state.fetchingAuthor = true;
                state.error = null;
            })
            .addCase(getDetailMigrateAuthors.fulfilled, (state, action) => {
                state.fetchingAuthor = false;
                state.currentAuthor = action.payload?.data;
            })
            .addCase(getDetailMigrateAuthors.rejected, (state, action) => {
                state.fetchingAuthor = false;
                state.error = action.payload;
            })

            // Blog Migrate

            .addCase(migrateQuickEditApi.pending, (state) => {
                state.fetchingAuthor = true;
                state.error = null;
            })
            .addCase(migrateQuickEditApi.fulfilled, (state, action) => {
                state.fetchingAuthor = false;
            })
            .addCase(migrateQuickEditApi.rejected, (state, action) => {
                state.fetchingAuthor = false;
                state.error = action.payload;
            })

    }
});

export default blogsSlice.reducer;
